export enum BankResponseType {
    Match = 1,
    CloseMatch = 2,
    NoMatch = 3,
    AccountNotFound = 4
}